import { all, call } from 'redux-saga/effects';

import { searchSagas } from '../_sagas/search.sagas';
import { authenticationSagas } from '../_sagas/authentication.sagas';
import { favoriteSagas } from '../_sagas/favorite.sagas';
import { hotfundSagas } from '../_sagas/hotfund.sagas';
import { compareSagas } from '../_sagas/compare.sagas';
import { investmentSagas } from '../_sagas/investment.sagas';
import { informationSagas } from '../_sagas/information.sagas';
import { orderRequestSagas } from '../_sagas/order-request.sagas';
import { advanceSearchSagas } from '../_sagas/advance-search.sagas';
import { ipoSagas } from '../_sagas/ipo.sagas';
import { fundRankingSagas } from '../_sagas/fund-ranking.sagas';
import { monthlyReportSagas } from '../_sagas/monthly-report.sagas';
import { calendarSagas } from '../_sagas/calendar.sagas';
import { HomeSagas } from '../_sagas/home.sagas';
import { generalSagas } from '../_sagas/general.sagas';

export default function* rootSaga() {
  yield all([
    call(searchSagas),
    call(authenticationSagas),
    call(favoriteSagas),
    call(investmentSagas),
    call(informationSagas),
    call(orderRequestSagas),
    call(hotfundSagas),
    call(compareSagas),
    call(advanceSearchSagas),
    call(ipoSagas),
    call(fundRankingSagas),
    call(monthlyReportSagas),
    call(calendarSagas),
    call(HomeSagas),
    call(generalSagas)
  ]);
}
